// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BoxPlotTwoToneSvg from "@ant-design/icons-svg/es/asn/BoxPlotTwoTone";
import AntdIcon from '../components/AntdIcon';

var BoxPlotTwoTone = function BoxPlotTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotTwoToneSvg
  }));
};

BoxPlotTwoTone.displayName = 'BoxPlotTwoTone';
export default React.forwardRef(BoxPlotTwoTone);